export const dialogStyle = {
  "& .MuiPaper-root": {
    maxWidth: "1200px",
    display: "flex",
    flexDirection: "column",
  },
};

export const dialogBox = {
  height: { xs: "100%", sm: "min(800px, calc(100dvh - 64px))" },
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
};

export const dialogContentStyle = {
  p: 0,
  flex: 1,
  display: "flex",
  flexDirection: { xs: "column", sm: "row" },
  background: { xs: "#F9F9FC", sm: "none" },
  overflow: "hidden",
};

export const footerStyle = {
  paddingY: "12px",
  paddingX: "24px",
  boxShadow: "0px -3px 8px 0px #2F2B3D14",
  zIndex: 1,
};

export const headerBoxStyle = {
  paddingX: { xs: "16px", md: "24px" },
  paddingY: "12px",
  borderBottom: "1px solid #EAEAEA",
  boxShadow: { xs: "none", md: "0px 3px 8px 0px #2F2B3D14" },
  zIndex: 1,
};

export const chipStyle = {
  paddingX: "8px",
  paddingY: "4px",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "20px",
  height: "26px",
  width: "max-content",
  mx: "auto",
  borderRadius: "4px",
  "& span": {
    padding: "0px",
  },
};

export const orderDetailsContainerStyle = {
  flexBasis: { xs: "100%", sm: "750px" },
  background: { xs: "#fff", md: "#f8f7fa" },
  padding: { xs: "0px", md: "32px" },
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  overflowY: "auto",
};

export const subContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "18px",
};

export const subContainerHeadingStyle = { fontSize: "16px", fontWeight: "600" };

export const visitPriceBoxStyle = {
  padding: "12px",
  backgroundColor: "rgba(255, 255, 255, 1)",
  borderRadius: "8px",
  border: "1px solid rgba(234, 234, 234, 1)",

  "& p": {
    fontSize: "14px",
    color: "rgba(72, 72, 72, 1)",
  },
};

// Digital-delivery notice (COMY1-334): the order carries a digital item the
// supplier has to send the client electronically. Brand-green info box so it
// reads as guidance, not as an error.
export const digitalNoticeBoxStyle = {
  padding: "12px",
  backgroundColor: "rgba(28, 160, 138, 0.08)",
  border: "1px solid rgba(28, 160, 138, 0.3)",
  borderRadius: "8px",
  display: "flex",
  alignItems: "flex-start",
  gap: "8px",

  "& p": {
    fontSize: "14px",
    color: "rgba(62, 63, 76, 0.9)",
  },
};

// "Digital Product" pill shown next to a digital line in the items table.
export const digitalProductTagStyle = {
  display: "inline-flex",
  alignItems: "center",
  marginInlineStart: "8px",
  padding: "2px 8px",
  borderRadius: "6px",
  backgroundColor: "rgba(28, 160, 138, 0.12)",
  color: "rgba(28, 160, 138, 1)",
  fontSize: "12px",
  fontWeight: 500,
  whiteSpace: "nowrap",
};

export const additionalInfoImageContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "12.8px",
};

export const additionalInfoImageWrapperStyle = {
  width: "123px",
  height: "96px",
  borderRadius: "7.33px",
  position: "relative",
};

export const additionalInfoImageStyle = {
  objectFit: "cover",
  borderRadius: "7.33px",
  width: "100%",
  height: "100%",
};

export const additionalInfoTextStyle = { fontSize: "14px", fontWeight: "400" };

export const communityDetailsContainerStyle = {
  flexBasis: { xs: "100%", sm: "450px" },
  borderLeft: { xs: "none", md: "1px solid rgba(234, 234, 234, 1)" },
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
};

export const communityDetailsSubContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  paddingX: { xs: "0px", md: "32px" },
  paddingY: "24px",
  borderBottom: "1px solid rgba(234, 234, 234, 1)",
};

export const communityDetailsHeadingStyle = {
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "24px",
  textTransform: "uppercase",
};

export const communityDetailsSubHeadingStyle = {
  fontSize: "16px",
  fontWeight: "600",
  lineHeight: "24px",
  textTransform: "uppercase",
};

export const clientCommunityDetailsContainerStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

export const clientDetailsWrapper = {
  display: "flex",
  gap: "16px",
  alignItems: "center",
  justifyContent: "space-between",
};

export const communityDetailsLogoTextWrapper = {
  display: "flex",
  gap: "12px",
  alignItems: "center",
};

export const communityDetailsTextStyle = {
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "20px",
};

export const timeLocationRowStyle = {
  display: "flex",
  justifyContent: "space-between",
  gap: "32px",
};

export const timeLocationKeyStyle = {
  ...communityDetailsTextStyle,
  fontWeight: "400",
  whiteSpace: "nowrap",
  flexShrink: 0,
};

export const timeLocationValueStyle = {
  ...communityDetailsTextStyle,
  wordBreak: "break-word",
  textAlign: "end",
};

export const totalRowStyle = {
  ...timeLocationRowStyle,
  borderTop: "1px solid rgba(234, 234, 234, 1)",
  paddingY: "24px",
};

export const totalRowTextStyle = {
  ...communityDetailsTextStyle,
  fontWeight: 700,
};

export const VATTextStyle = {
  ...communityDetailsTextStyle,
  fontSize: "12px",
  fontWeight: 500,
};

export const actionButtonStyle = {
  backgroundColor: "#257C6D",
  color: "white",
  fontSize: 15,
  fontWeight: 400,
  lineHeight: "22px",
  textTransform: "none",
  borderRadius: "8px",
  paddingX: "12px",
  paddingY: "8px",
  height: "39px",
  boxShadow: "none !important",
  "&:hover": { backgroundColor: "#1F6A5A" },
  "&:disabled": { backgroundColor: "#257C6D", color: "white", opacity: 0.3 },
};

export const declineActionBtn = {
  ...actionButtonStyle,
  backgroundColor: "#A5A5A5",
  "&:hover": { backgroundColor: "#8C8C8C" },
  "&:disabled": { backgroundColor: "#A5A5A5", color: "white", opacity: 0.3 },
};

export const loader = {
  color: "rgba(255, 255, 255, 1)",
  ml: "8px",
};

// export const exampleImageTextWrapperStyle = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   padding: "4px",
//   borderRadius: "12px",
//   backgroundColor: "rgba(135, 135, 135, 1)",
//   color: "rgba(255, 255, 255, 1)",
//   fontSize: "10px",
//   fontWeight: 500,
//   zIndex: 1,
//   whiteSpace: "nowrap",
//   height: "15px",
//   display: "flex",
//   alignItems: "center",
//   justifyContent: "center",
// };
